module.exports = __webpack_public_path__ + "fa-brands-400.ttf?85262751112488d75ac1686fcabc01bc";